"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appRender = void 0;
const renderUtils_1 = require("../appLoaders/utils/renderUtils");
const appRender = async ({ entrypoint }) => {
    entrypoint((0, renderUtils_1.getRootElement)());
};
exports.appRender = appRender;
//# sourceMappingURL=app.render.js.map